import type { Routes } from '@angular/router';
import { ContactFeature, defaultTitleResolver, PageContentType } from '@hyundai/ng-common-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ContactPageComponent } from './contact-page.component';

export default [
    {
        path: '',
        component: ContactPageComponent,
        providers: [provideState(ContactFeature.state), provideEffects([ContactFeature.effects])],
        title: defaultTitleResolver('Kontakt'),
        data: {
            contentType: PageContentType.CONTACTFORM,
        },
    },
] satisfies Routes;
